module.exports = {
  loginPrefix: 'login',
  teacherSignInPath: '/login/teacher/sign-in',
  studentSignInPath: '/login/student/sign-in',
  studentPrefix: '/student',
  classroomCourseware: '/classroom-courseware',
  intelligenceCourseware: '/intelligence-courseware',
  intelligenceResource: '/intelligence-resource',
  fsAgentMaterial: '/fs-agent-material',
  cloudDisk: '/cloud-disk',
};
